<template>
  <div ref="tagsRootRef" class="review-card-tags flex flex-row flex-wrap gap-2">
    <div
      v-for="(tag, i) in props.tags"
      v-show="tagsDisplayStatus[i]"
      :key="tag.id"
      ref="tagsRef"
      class="px-2 py-0.5 bg-gray-20 text-gray-80 text-xs rounded"
    >
      {{ tag.name }}
    </div>
    <div v-show="isShowAppendTag" class="append-tag px-2 py-0.5 bg-gray-20 text-gray-80 text-xs rounded">
      {{ APPEND_TAG.name }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ReviewReviewTag } from '@/types/api'

const APPEND_TAG = { name: '...' }
const APPEND_TAG_WIDTH = 40
const TAG_GAP = 8

const props = defineProps<{
  tags: ReviewReviewTag[]
  oneLine?: boolean
}>()

const tagsRootRef = ref<Nullable<HTMLElement>>(null)
const tagsRef = ref<HTMLElement[]>([])
const { width: tagsRootWidth } = useElementSize(tagsRootRef)

const tagsWidth = computed(() => tagsRef.value.map(tag => tag.offsetWidth))

const tagsDisplayStatus = computed(() => {
  if (!props.oneLine) return Array.from({ length: props.tags.length }, () => true)

  const result = Array.from({ length: props.tags.length }, () => false)

  for (let space = tagsRootWidth.value, i = 0; i < props.tags.length; i++) {
    const tagWidth = tagsWidth.value[i]

    if (space - tagWidth - TAG_GAP < APPEND_TAG_WIDTH) break

    result[i] = true
    space -= tagWidth + TAG_GAP
  }

  return result
})

const isShowAppendTag = computed(() => {
  if (!props.oneLine) return false

  return props.tags.length && tagsDisplayStatus.value[tagsDisplayStatus.value.length - 1] === false
})

onBeforeUnmount(() => {
  tagsRef.value = []
})
</script>
